import { makeStyles } from "e100-react-components";

import { ProLabelProps } from './ui';

interface StyleProps extends Pick<ProLabelProps, 'margin'> {}

export const useStyles = makeStyles(({ spacing, palette, shape }) => ({
  chip: ({ margin = {} }: StyleProps) => ({
    padding: `${spacing(0.25)}px ${spacing(0.75)}px`,
    borderRadius: shape.borderRadius,
    color: palette.common.white,
    backgroundColor: palette.primary.main,
    fontSize: 11,
    ...typeof margin === 'number' && {
      margin: spacing(margin)
    },
    ...typeof margin === 'object' && margin.top && { marginTop: spacing(margin.top) },
    ...typeof margin === 'object' && margin.right && { marginRight: spacing(margin.right) },
    ...typeof margin === 'object' && margin.bottom && { marginBottom: spacing(margin.bottom) },
    ...typeof margin === 'object' && margin.left && { marginLeft: spacing(margin.left) },
  }),
}));
